import App from 'App'
import { createRoot } from 'react-dom/client'
import 'reset.scss'

import loadData from 'data/load'
//import rawProfile from './profile.json';
import { Api } from 'api'
import Locale from 'data/locale'
import ErrorReporter from 'error'
import { profileFix } from 'logic/profileReducers'
import Store from 'store'
import EditingContext from 'store/editingContext'
import History from 'store/history'
import Session from 'store/session'

const dataLoaded = loadData()

;(async function () {
  const editingContext = new EditingContext()

  let loading = null
  const match = window.location.pathname.match(/\/(\d+)$/)
  if (match) {
    const setName =
      window.location.hash &&
      decodeURIComponent(window.location.hash.substring(1))
    loading = new Api().load(parseInt(match[1])).then(
      async (result) => {
        await dataLoaded
        if (result.profiles) {
          result.profiles = result.profiles.map((profile) =>
            profileFix(profile)
          )
          if (!result.profiles[result.activeProfile]) {
            result.activeProfile = 0
          }
          if (setName) {
            const index = result.profiles.findIndex(
              (profile) => profile.name === setName
            )
            if (index >= 0) {
              result.activeProfile = index
            }
          }
        } else {
          const _L = Locale('ui-timeline.js')
          const prevName = result.name
          result.name = _L`Set ${1}`
          result = {
            profiles: [profileFix(result)],
            activeProfile: 0,
            active: {}
          }
          if (prevName) {
            result.name = prevName
          }
        }
        await Store.instance.setState(result)
        const profile = result.profiles[result.activeProfile]
        if (profile.buildinfo?.text) {
          editingContext.dispatch({ type: 'buildinfo' })
        }
      },
      (error) => error.message
    )
  }

  await dataLoaded
  // uncomment this if you want to wait for profile load before rendering the page
  //if (loading) await loading;

  const history = new History(Store.instance)

  const session = new Session()
  const api = new Api(session.store)

  api.updateLoginFrontend()

  //history.subscribe(state => state, state => console.log(state));

  createRoot(document.getElementById('d3planner-wrapper')).render(
    <ErrorReporter history={history}>
      <App
        history={history}
        session={session}
        loading={loading}
        editingContext={editingContext}
      />
    </ErrorReporter>
  )
})()
